<div
  class="hd-doc-viewer"
  [class.hd-doc-viewer--floating]="isFloating()"
  [class.hd-doc-viewer--wide]="isWide()"
  (click)="onContentClick($event)"
  (keydown.enter)="onContentKeydown($event)"
>
  @if (canGoBack()) {
    <button
      type="button"
      class="hd-doc-viewer__back hd-doc-viewer__back--top"
      (click)="goBack(); $event.stopPropagation()"
    >
      <i class="fas fa-arrow-left" aria-hidden="true"></i>
      <span>{{ 'humanDesign.chart.configurator.docPanel.backTo' | transloco: { label: previousLabel() } }}</span>
    </button>
  }

  <div class="hd-doc-viewer__content">
    @switch (currentKind()) {
      @case ('circuit') {
        @if (circuitContext(); as ctx) {
          <hd-circuit-info-full [context]="ctx" />
        }
      }
      @case ('overview') {
        <hd-circuits-overview-info [context]="overviewContext" />
      }
      @case ('channels-overview') {
        <hd-channels-overview-info />
      }
      @default {
        @if (markdownUrl(); as url) {
          <markdown class="hd-doc-viewer__md" [src]="url"></markdown>
        }
      }
    }

    <!-- Vast blokje onder elk kanaaldocument: doorsteek naar het overzicht van
         alle 36 kanalen per type (zelfde paneel, terug via de history). -->
    @if (currentKind() === 'channel') {
      <button
        type="button"
        class="hd-doc-viewer__all-channels"
        (click)="openAllChannels(); $event.stopPropagation()"
      >
        <i class="fas fa-list" aria-hidden="true"></i>
        <span>{{ allChannelsLabel() }}</span>
        <i class="fas fa-chevron-right hd-doc-viewer__all-channels-chevron" aria-hidden="true"></i>
      </button>
    }
  </div>

  @if (canGoBack()) {
    <button
      type="button"
      class="hd-doc-viewer__back hd-doc-viewer__back--bottom"
      (click)="goBack(); $event.stopPropagation()"
    >
      <i class="fas fa-arrow-left" aria-hidden="true"></i>
      <span>{{ 'humanDesign.chart.configurator.docPanel.backTo' | transloco: { label: previousLabel() } }}</span>
    </button>
  }
</div>
